import CriarCustomPesquisa from './CriarCustomPesquisa'
import enhance from './CriarCustomPesquisa.enhancer'

export default enhance(CriarCustomPesquisa)



// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/components/CriarCustomPesquisa/index.js